 import React, { Component } from 'react'

require(`../assets/${process.env.PAGE}/css/file-field.css`);

class Upload extends Component {
  constructor(props){
    super(props)
    this.state = {
      files: null,
      file: {
        url: null,
        type: null,
        size: null,
        name: null,
      }
    }
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(event) {
    this.setState({
      ...this.state,
      file:{
        url: URL.createObjectURL(event.target.files[0]),
        type: event.target.files[0].type,
        size: event.target.files[0].size,
        name: event.target.files[0].name,
        blob: event.target.files[0]
      },
      files: event.target.files
    })
    this.props.onChange(event.target.files[0]);
  }
  render() {

    return (
      <div className={"container-summit-upload-file"}>
        <label className={'summit-upload-file'}>
          <input type="file"
                style={{display: 'none'}}
                onChange={this.handleChange} />
          <div className={'without-content'}>
            +
          </div>
        </label>
      </div>
    );
  }
}
module.exports = Upload


/** WEBPACK FOOTER **
 ** ./src/components/FileField.js
 **/